import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { endSupportMode, getSupportMode, registerReasonPrompt, SUPPORT_EVENT } from "../supportMode";

// Asks for the reason when data per person is needed, and shows that support mode is on (with a way to end it)
export default function SupportModeDialog() {
  const [t] = useTranslation("global");
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [mode, setMode] = useState(getSupportMode());
  const resolveRef = useRef<((reason: string | null) => void) | null>(null);

  useEffect(() => {
    registerReasonPrompt(
      () =>
        new Promise<string | null>((resolve) => {
          resolveRef.current = resolve;
          setReason("");
          setOpen(true);
        })
    );
    const update = () => setMode(getSupportMode());
    window.addEventListener(SUPPORT_EVENT, update);
    const interval = setInterval(update, 30000);
    return () => {
      registerReasonPrompt(null);
      window.removeEventListener(SUPPORT_EVENT, update);
      clearInterval(interval);
    };
  }, []);

  const close = (value: string | null) => {
    setOpen(false);
    resolveRef.current?.(value);
    resolveRef.current = null;
  };

  return (
    <>
      {mode && (
        <Box sx={{ border: "1px solid #EB6608", borderRadius: "8px", margin: "1% auto", width: "90%", padding: "8px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
          <Typography variant="body2">
            {t("support.active", { reason: mode.reason, until: new Date(mode.until).toLocaleTimeString("da-DK", { hour: "2-digit", minute: "2-digit" }) })}
          </Typography>
          <Button variant="outlined" size="small" onClick={endSupportMode} sx={{ color: "#EB6608", borderColor: "#EB6608" }}>
            {t("support.end")}
          </Button>
        </Box>
      )}
      <Dialog open={open} onClose={() => close(null)} maxWidth="sm" fullWidth>
        <DialogTitle>{t("support.title")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t("support.intro")}</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="supportReason"
            label={t("support.reason")}
            fullWidth
            variant="standard"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            helperText={t("support.reasonHint")}
          />
        </DialogContent>
        <DialogActions>
          <Button sx={{ color: "#EB6608" }} onClick={() => close(null)}>
            {t("support.cancel")}
          </Button>
          <Button sx={{ color: "#EB6608" }} disabled={reason.trim().length < 10} onClick={() => close(reason.trim())}>
            {t("support.start")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
